var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('mex-buscar-sucursal',{attrs:{"data":_vm.data},on:{"update:filteredOfficesRegion":_vm.updateFilteredOffices}}),_vm._v(" "),_c('mex-sucursal-respuesta',{attrs:{"filteredOffices":_vm.filteredOffices}}),_vm._v(" "),_c('div',{staticClass:"column is-full my-5 pb-0"},[_c('scroll-to-top-button')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }